import React, {Component} from "react";
import Provider from "pubsub-js";
import {OBJECT_ROTATING, CANVAS_MODIFIED} from "../../constants/event-types";

export class AngleLabel extends Component {
  state = {
    angle: 0,
    left: 0,
    top: 0,
    isShow: false
  };

  componentDidMount() {
    Provider.subscribe(OBJECT_ROTATING, this.onObjectRotating);
    Provider.subscribe(CANVAS_MODIFIED, this.onCanvasModified);
  }
  componentWillUnmount() {
    Provider.unsubscribe(this.onObjectRotating);
    Provider.unsubscribe(this.onCanvasModified);
  }
  onObjectRotating = (_, memo) => {
    const {
      e: {x, y, touches},
      target: {angle}
    } = memo;

    const left = x ? x + 20 : touches[0].clientX + 20;
    const top = y ? y - 30 : touches[0].clientY - 30;
    this.setState({
      left,
      top,
      angle: Math.round(angle),
      isShow: true
    });
  };
  onCanvasModified = () => {
    this.setState({
      isShow: false
    });
  };

  render() {
    const {isShow, angle, left, top} = this.state;
    return isShow ? (
      <span
        className="angle-label"
        style={{left: `${left}px`, top: `${top}px`}}
      >
        {angle}&deg;
      </span>
    ) : null;
  }
}

export default AngleLabel;
